/**
 * Topic Quiz Localized Data
 */
export const TOPIC_QUIZZES = {
    love: {
        articleId: 107,
        vi: {
            q: 'Vì sao có những người yêu nhau sâu đậm nhưng cuối cùng vẫn phải chia xa?',
            options: ['Do không hợp nhau', 'Do gia đình ngăn cấm', 'Do số phận'],
            intro: 'Có những mối tình tưởng như sinh ra để thuộc về nhau, yêu thương sâu đậm nhưng cuối cùng vẫn lỡ mất nhau. Vì sao hai người có thể gặp gỡ, yêu thương, đồng hành rồi lại chia lìa? Hãy cùng khám phá những câu chuyện về tình duyên, nhân quả và duyên phận để tìm lời giải đáp.'
        },
        en: {
            q: 'Why do some people who love each other deeply still end up apart?',
            options: ['They weren\'t compatible', 'Their families opposed it', 'It was fate'],
            intro: 'Some loves seem destined to belong together — deep and devoted — yet still slip away. Why can two people meet, love, walk side by side, and then part? Explore these stories of love, karma and predestined bonds to find the answer.'
        },
        'zh-TW': {
            q: '為什麼有些人深深相愛，最終卻還是不得不分離？',
            options: ['彼此不合適', '家人反對', '命中注定'],
            intro: '有些愛情彷彿生來就屬於彼此，愛得深切，最終卻還是錯過了。為什麼兩個人能夠相遇、相愛、相伴，最後卻又分離？讓我們一起探索關於姻緣、因果與緣分的故事，尋找答案。'
        },
        'zh-CN': {
            q: '为什么有些人深深相爱，最终却还是不得不分离？',
            options: ['彼此不合适', '家人反对', '命中注定'],
            intro: '有些爱情仿佛生来就属于彼此，爱得深切，最终却还是错过了。为什么两个人能够相遇、相爱、相伴，最后却又分离？让我们一起探索关于姻缘、因果与缘分的故事，寻找答案。'
        }
    },
    finance: {
        articleId: 107,
        vi: {
            q: 'Theo bạn, vì sao có người dễ dàng kiếm được tiền. Có người dù nỗ lực đến đâu cũng không có được tiền tài như mong muốn?',
            options: ['Do phúc phận của mỗi người', 'Tư duy tài chính', 'Năng lực, cơ hội khác nhau'],
            intro: 'Liệu thành bại hay đắc được tiền tài chỉ phụ thuộc vào năng lực và sự cố gắng, hay còn có những nguyên nhân sâu xa hơn mà chúng ta chưa nhìn thấy? Mời bạn đọc những bài viết sau để tìm lời giải đáp.'
        },
        en: {
            q: 'Why do some people make money easily, while others never gain the wealth they hope for no matter how hard they try?',
            options: ['Each person\'s fortune', 'Financial mindset', 'Different abilities and opportunities'],
            intro: 'Do success and wealth depend only on ability and effort — or are there deeper causes we have yet to see? Read the following articles to find the answer.'
        },
        'zh-TW': {
            q: '你認為，為什麼有人輕鬆就能賺到錢，有人無論多努力，卻始終得不到想要的財富？',
            options: ['每個人的福分不同', '理財思維', '能力與機遇不同'],
            intro: '成敗與財富，真的只取決於能力和努力嗎？還是有更深層、我們尚未看見的原因？請閱讀以下文章，尋找答案。'
        },
        'zh-CN': {
            q: '你认为，为什么有人轻松就能赚到钱，有人无论多努力，却始终得不到想要的财富？',
            options: ['每个人的福分不同', '理财思维', '能力与机遇不同'],
            intro: '成败与财富，真的只取决于能力和努力吗？还是有更深层、我们尚未看见的原因？请阅读以下文章，寻找答案。'
        }
    },
    health: {
        articleId: 104,
        vi: {
            q: 'Theo bạn, khi một người mắc trọng bệnh và y học dường như đã bất lực, phương pháp nào sau đây có thể giúp họ?',
            options: ['Trung y, y học cổ truyền', 'Khí công, thiền định', 'Cầu nguyện, tu dưỡng tâm tính'],
            intro: 'Đứng trước bệnh hiểm nghèo, liệu y học có phải là con đường duy nhất? Những câu chuyện kỳ diệu dưới đây có thể khiến chúng ta nhìn nhận hành trình vượt qua bệnh tật dưới một góc độ mới. Mời bạn cùng khám phá.'
        },
        en: {
            q: 'When someone is seriously ill and medicine seems to have run out of options, which of these do you think could help them?',
            options: ['Traditional Chinese medicine', 'Qigong and meditation', 'Prayer and cultivating one\'s character'],
            intro: 'Facing a life-threatening illness, is medicine the only path? The remarkable stories below may change how we see the journey of overcoming illness. Come and explore.'
        },
        'zh-TW': {
            q: '你認為，當一個人身患重病、醫學似乎已無能為力時，下列哪種方法能幫助他？',
            options: ['中醫、傳統醫學', '氣功、打坐冥想', '祈禱、修心養性'],
            intro: '面對絕症，醫學是唯一的出路嗎？下面這些神奇的故事，或許能讓我們從全新的角度看待戰勝疾病的歷程。邀請你一同探索。'
        },
        'zh-CN': {
            q: '你认为，当一个人身患重病、医学似乎已无能为力时，下列哪种方法能帮助他？',
            options: ['中医、传统医学', '气功、打坐冥想', '祈祷、修心养性'],
            intro: '面对绝症，医学是唯一的出路吗？下面这些神奇的故事，或许能让我们从全新的角度看待战胜疾病的历程。邀请你一同探索。'
        }
    },
    work: {
        articleId: 102,
        vi: {
            q: 'Theo bạn, công danh, sự nghiệp, tiền tài từ đâu mà có?',
            options: ['Sự nỗ lực hết mình', 'Thời vận', 'Phúc phận'],
            intro: 'Có người cả đời thuận lợi, làm gì cũng gặp may, trong khi có người lại liên tiếp gặp trắc trở, mọi việc đều chẳng như ý. Vậy công danh, sự nghiệp và những được – mất trong đời thực sự bắt nguồn từ đâu? Mời bạn đọc bài viết dưới đây để cùng tìm lời giải đáp.'
        },
        en: {
            q: 'Where do you think career success, status and wealth come from?',
            options: ['Giving it your all', 'Timing and luck', 'One\'s fortune'],
            intro: 'Some people sail through life, lucky in everything they do, while others meet setback after setback and nothing goes their way. So where do career, success and life\'s gains and losses truly come from? Read the article below to find the answer.'
        },
        'zh-TW': {
            q: '你認為，功名、事業與財富從何而來？',
            options: ['全力以赴的努力', '時運', '福分'],
            intro: '有人一生順遂，做什麼都很幸運；有人卻接連受挫，諸事不順。那麼，功名、事業以及人生的得與失，究竟源自何處？請閱讀下面的文章，一起尋找答案。'
        },
        'zh-CN': {
            q: '你认为，功名、事业与财富从何而来？',
            options: ['全力以赴的努力', '时运', '福分'],
            intro: '有人一生顺遂，做什么都很幸运；有人却接连受挫，诸事不顺。那么，功名、事业以及人生的得与失，究竟源自何处？请阅读下面的文章，一起寻找答案。'
        }
    },
    reincarnation: {
        articleId: 108,
        vi: {
            q: 'Bạn có tin vào luân hồi?',
            options: ['Có', 'Không', 'Chưa chắc chắn'],
            intro: 'Luân hồi có thật hay chỉ là một niềm tin? Những câu chuyện dưới đây sẽ đưa bạn đến gần hơn với một bí ẩn mà con người đã đặt câu hỏi từ hàng nghìn năm nay.'
        },
        en: {
            q: 'Do you believe in reincarnation?',
            options: ['Yes', 'No', 'Not sure'],
            intro: 'Is reincarnation real, or just a belief? The stories below will bring you closer to a mystery humanity has pondered for thousands of years.'
        },
        'zh-TW': {
            q: '你相信輪迴嗎？',
            options: ['相信', '不相信', '不確定'],
            intro: '輪迴是真實存在，還是只是一種信仰？下面的故事將帶你更接近這個人類追問了數千年的謎題。'
        },
        'zh-CN': {
            q: '你相信轮回吗？',
            options: ['相信', '不相信', '不确定'],
            intro: '轮回是真实存在，还是只是一种信仰？下面的故事将带你更接近这个人类追问了数千年的谜题。'
        }
    }
};
